import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'
import { DEFAULT_ICON_COLOR } from '../constants/icon-consts'

export const CurrencyDollarCircleIcon = (props?: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill={DEFAULT_ICON_COLOR}
    {...props}
  >
    <title>{props?.title}</title>
    <path d="M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM14.5 9.33301C14.4998 8.59689 13.9031 8.00018 13.167 8H11C10.1716 8 9.5 8.67157 9.5 9.5C9.5 10.3284 10.1716 11 11 11H13C14.933 11 16.5 12.567 16.5 14.5C16.5 16.433 14.933 18 13 18V18.5C13 19.0523 12.5523 19.5 12 19.5C11.4477 19.5 11 19.0523 11 18.5V18H10.833C8.99232 17.9998 7.50018 16.5077 7.5 14.667C7.5 14.1147 7.94772 13.667 8.5 13.667C9.05228 13.667 9.5 14.1147 9.5 14.667C9.50018 15.4031 10.0969 15.9998 10.833 16H13C13.8284 16 14.5 15.3284 14.5 14.5C14.5 13.6716 13.8284 13 13 13H11C9.067 13 7.5 11.433 7.5 9.5C7.5 7.567 9.067 6 11 6V5.5C11 4.94772 11.4477 4.5 12 4.5C12.5523 4.5 13 4.94772 13 5.5V6H13.167C15.0077 6.00018 16.4998 7.49232 16.5 9.33301C16.5 9.88529 16.0523 10.333 15.5 10.333C14.9477 10.333 14.5 9.88529 14.5 9.33301ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z" />
  </svg>
)
